import { ApolloClient, ApolloLink } from "@apollo/client";
import { authLink } from "api/client/authLink";
import { cache } from "api/client/cache";
import { errorLink } from "api/client/errorLink";
import { httpLink } from "api/client/httpLink";

const link = ApolloLink.from([authLink, errorLink, httpLink]);

export const client = new ApolloClient({ link, cache });
